<style lang="scss" scoped>
.btn {
  width: 200px;
  height: 40px;
  margin: 0 auto;
  border-radius: 2px;
  &:hover {
    cursor: pointer;
  }
  img {
    width: 200px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2083e0;
    line-height: 40px;
  }
}
</style>
<template>
  <div style="padding-top: 30px">
    <a :href="QWLoginUrl">
      <div class="btn">
        <img
          :src="require('@/assets/img/qwLogin/qwImg/login_white_middle.png')"
          alt=""
        >
      </div>
    </a>
  </div>
</template>
<script>
import { QWLogin } from '@/api/qwAuth'
export default {
  name: 'SpQwAuth',
  components: {},
  data () {
    return {
      QWLoginUrl: ''
    }
  },
  watch: {},
  created () {
    this.getQWLoginUrl()
  },
  mounted () {},
  methods: {
    //获取企微登录接口
    getQWLoginUrl () {
      QWLogin({
        channel_source: '1',
        redirect_uri: `${location.origin}/qwAuth/bindPhone`
      }).then((res) => {
        this.QWLoginUrl = res.url
      })
    }
  }
}
</script>
